import fetchFromApiServer from 'services/api';

export function getPortfolios(requestObject) {
  const url = `pacing-plan/getPortfolios`;
  return fetchFromApiServer('GET', url, requestObject);
}
